module.exports = __webpack_public_path__ + "img/94856.87a94fa4.svg";